import FundApplication from "src/components/feature/FundApplication";

const DefaultFundApplication = () => {
  return <FundApplication />;
};

export default DefaultFundApplication;
